































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
//import userPerformanceChart from "@/components/users/userPerformanceChart.vue";
import userFillersChart from "@/components/users/userFillersChart.vue";
import player from "@/components/Player.vue";
import transcript from "@/components/users/userTranscript.vue";
import consts from "@/consts";
import { findUser } from "@/utils";
import { User, UserStat, TeamActivity } from "@/types";
import axios from "axios";
import moment from "moment";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    userSettings,
    //userPerformanceChart,
    userFillersChart,
    player,
    transcript
  },
  filters: {
    moment(date: string) {
      return moment(date).format("l");
    }
  }
})
export default class UserPage extends Vue {
  @Getter private JWT!: string;
  @Getter private currentTeam!: any;
  @Getter private currentTeamUsers!: User[];
  @Getter private currentTeamStats!: UserStat[];
  @Action private fetchCurrentTeamStats!: () => any;

  @Prop() private isValidRoute!: (teamID: any, userID: any) => boolean;

  @Prop() private userID!: string;
  @Prop() private teamID!: string;

  private activityCurrentPage: number = 1;
  private totalRows: number = 0;
  private userActivity: any[] = [];
  //private clarityData: any[] = [];
  //private pacingData: any[] = [];
  //private fillerData: any[] = [];
  private userFillers: any = {};
  private currentSessionID: string | null = null;
  private sessionData: any = {};
  private fillersDropdownOpen: boolean = false;
  private userActivityFetching: boolean = false;
  private fields: any = [
    {
      key: "Date",
      label: "Date",
      sortable: true
    },
    {
      key: "Title",
      label: "Title",
      sortable: true
    },
    {
      label: "Title",
      sortable: true,
      key: "Title"
    },
    {
      key: "Duration",
      label: "Duration",
      sortable: true
    },
    {
      key: "Filler",
      label: "Fillers",
      sortable: true
    },
    {
      key: "Pacing",
      label: "Pacing (WPM)",
      sortable: true
    },
    {
      key: "Confidence",
      label: "Confidence Score",
      sortable: true
    }
  ];
  private activityFilter: string = "";
  private userFilter: string = "";

  private created() {
    this.fetchCurrentTeamStats();
    if (this.currentTeam && this.currentTeamUsers) {
      this.fetchUserActivity(this.teamID, this.userID);
    }
  }

  private mounted() {
    this.$root.$on("bv::dropdown::show", this.handleDropdownOpen);
  }

  private beforeDestroy() {
    this.$root.$off("bv::dropdown::show", this.handleDropdownOpen);
  }

  private onFiltered(filteredItems: any[]) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.activityCurrentPage = 1;
  }

  private rowClicked(item: any) {
    let sessionID = item.ID;
    if (sessionID) {
      this.$router.push({
        name: "reviewSession",
        params: {
          teamID: this.teamID,
          //userID: this.userID,
          sessionID
        }
      });
    }
  }

  private secondsToFormat(duration: number) {
    return moment.utc(duration * 1000).format("mm:ss");
  }

  private handleDropdownOpen(e: any) {
    const dropdownRef = this.$refs.mostCommonFillersDropdown as any;
    if (dropdownRef && e.target.parentNode === dropdownRef.$el) {
      this.fillersDropdownOpen = true;
    }
  }

  private fetchUserActivity(teamID: string, userID: string) {
    console.log(
      "VALID ROUTE",
      this.isValidRoute(teamID, userID),
      teamID,
      typeof teamID
    );
    if (!this.isValidRoute(teamID.toString(), userID)) {
      this.$router.push({ path: "/" });
      return;
    }

    if (this.userActivityFetching) {
      return;
    }

    this.userActivityFetching = true;
    axios
      .get(consts.serverURL + "team/" + teamID + "/user_statistics/" + userID, {
        headers: { Authentication: this.JWT }
      })
      .then(resp => {
        console.log("USER ACTIVTY", resp.data);
        if (resp.data.Sessions) {
          this.userActivity = resp.data.Sessions;
          this.totalRows = this.userActivity.length;

          // parse data for performance chart
          /* let clarityData = [];
          const pacingData = [];
          const fillerData = [];
          for (const i in resp.data.Sessions) {
            if (resp.data.Sessions.hasOwnProperty(i)) {
              const session = resp.data.Sessions[i];
              clarityData.push(session.Clarity);
              pacingData.push(session.Pacing);
              fillerData.push(session.Filler);
            }
          }
          this.clarityData = clarityData;
          this.pacingData = pacingData;
          this.fillerData = fillerData; */
        }
        this.userActivityFetching = false;
      });

    axios
      .get(consts.serverURL + "team/" + teamID + "/fillers?uid=" + userID, {
        headers: { Authentication: this.JWT }
      })
      .then(resp => {
        console.log("USER FILLERS", resp.data);
        this.userFillers = resp.data;
      });
  }

  get currentUser() {
    // Current Page User from Team Data
    let currUser = findUser(this.currentTeamStats, this.userID);
    if (currUser) {
      return currUser;
    } else {
      return findUser(this.currentTeamUsers, this.userID);
    }
  }

  get currUserStat() {
    // Current Page UserStat from TeamUserStat
    return findUser(this.currentTeamStats, this.userID); 
  }

  get prevUser() {
    return findUser(this.activeUsers, this.userID, -1);
  }

  get nextUser() {
    return findUser(this.activeUsers, this.userID, 1);
  }

  get activeUsers() {
    if (this.currentTeamUsers) {
      return this.currentTeamUsers.filter(user => {
        return user.AcceptedOn !== null && user.Role !== "manager";
      });
    }
    return [];
  }

  get filteredUsers() {
    return this.activeUsers.filter(user => {
      if (user.Name) {
        const userName = user.Name.toLowerCase();
        return userName.indexOf(this.userFilter.toLowerCase()) >= 0;
      }
      return false;
    });
  }

  @Watch("$route", { immediate: true, deep: true })
  private onUrlChange(newVal: any, oldVal: any) {
    if (this.currentTeam && this.currentTeamUsers) {
      // reset user state
      this.fillersDropdownOpen = false;
      this.userActivity = [];
      this.fetchUserActivity(this.teamID, this.userID);
    }
  }

  @Watch("currentTeamStats")
  private onUserStatsChanged(newVal: UserStat[], oldVal: UserStat[]) {
    if (
      newVal &&
      newVal !== oldVal &&
      this.currentTeam &&
      this.currentTeamUsers
    ) {
      this.fetchUserActivity(this.teamID, this.userID);
    }
  }

  @Watch("currentTeamUsers")
  private onCurrentTeamUsersChanged(newVal: any, oldVal: any) {
    if (newVal && newVal !== oldVal) {
      this.fetchUserActivity(this.teamID, this.userID);
    }
  }
}
